var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:['eb-button', _vm.size, _vm.state, _vm.hierarchy, _vm.withIcon, _vm.centered, _vm.expanded, _vm.siteColor],attrs:{"href":_vm.href,"type":_vm.tag=='a' ? null : _vm.type},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }